import { useState } from "react";
import { resturantDiscountDetailsOptions } from "../../dummyData";
import WhiteNavigator3 from "../navigators/WhiteNavigator3";
import DiscountCard from "../cards/DiscountCard";
const ResturantsDiscountsDetail = ({ details }) => {
  const [flowAt, setFlowAt] = useState(0);
  const getArrayByCategory = (category) => {
    return (
      details?.offers?.filter((item) => item?.category?.includes(category)) ||
      []
    );
  };
  const getItemsByCategory = () => {
    let datasArray = details?.offers || [];
    let allCategories = [
      "All",
      "Discount for groups",
      "Specific Day",
      "Single Use",
    ];
    switch (allCategories[flowAt]) {
      case "All":
        return datasArray;
      case "Discount for groups":
        return getArrayByCategory("group");
      case "Specific Day":
        return getArrayByCategory("specific_day");
      case "Single Use":
        return getArrayByCategory("single_entry");
      default:
        return datasArray;
    }
  };
  return (
    <div>
      <h4
        className="f-5 text-white mt-3 mb-5 text-center"
        style={{ letterSpacing: "9px" }}
      >
        Restaurant
      </h4>
      <div className="resturant-detail-div">
        <WhiteNavigator3
          className="p-2"
          items={resturantDiscountDetailsOptions}
          flowAt={flowAt}
          setFlowAt={setFlowAt}
        />
        <div className="mt-5">
          {getItemsByCategory()?.map((item, key) => (
            <DiscountCard
              key={item._id || key}
              {...item}
              name={details?.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default ResturantsDiscountsDetail;
